import {Accordion, AccordionSummary, Button, LinearProgress, Stack, Typography, styled} from '@mui/material';
import {colors} from '../../../shared/colors';

export const ProfileRoot = styled(Stack)(({theme}) => ({
  position: 'relative',
  width: 936,
  margin: '0 auto',
  backgroundColor: '#fff',
  padding: theme.spacing(4.25, 9, 9),
}));

export const ProfileContainer = styled(Stack)(({theme}) => ({
  minHeight: 798,
  backgroundColor: '#F5F6FA',
  padding: theme.spacing(3.25),
  marginTop: theme.spacing(4),
  borderRadius: 10,
}));

export const ProfileTitle = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 32,
  color: '#111827',
}));

export const SectionTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 18,
  lineHeight: '18px',
}));

export const AccordionRoot = styled(Accordion)(() => ({
  boxShadow: 'none',
  background: 'inherit',

  '&::before': {
    display: 'none',
  },
}));

export const AccordionSummaryRoot = styled(AccordionSummary)(() => ({
  width: 190,
  padding: 0,
  minHeight: 'unset',
  '& .MuiAccordionSummary-content': {
    margin: 0,
    alignItems: 'center',
  },
}));

export const AccordionTitle = styled(Typography)(() => ({
  fontWeight: 500,
  fontSize: 14,
  lineHeight: '18px',
  color: '#007DFF',
}));

export const ActionsRow = styled(Stack)(() => ({
  marginTop: 8,
}));

export const PrimaryButton = styled(Button)(() => ({
  height: 40,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '16px',
  background: '#0D99FF',
  textTransform: 'capitalize',
}));

export const SuccessButton = styled(Button)(({theme}) => ({
  height: 40,
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '16px',
  textTransform: 'capitalize',
  backgroundColor: '#3AC977',
  '&:hover': {
    backgroundColor: theme.palette.success.light,
  },
}));

export const ProgressBar = styled(LinearProgress)(() => ({
  height: 6,
  borderRadius: 999,
  backgroundColor: '#E5E7EB',
  '& .MuiLinearProgress-bar': {
    borderRadius: 999,
  },
}));

export const ProgressValue = styled(Typography)(() => ({
  fontWeight: 600,
  color: colors['icons--primary'],
}));

export const TariffTitle = styled(Typography)(() => ({
  fontWeight: 600,
  fontSize: 16,
}));

export const TariffDate = styled(Typography)(() => ({
  fontWeight: 400,
  fontSize: 14,
  color: '#6B7280',
}));
